export function buttonLayouts(buttonPosition) {
  switch (buttonPosition) {
    case 'start': {
      return `
      justify-content: start !important;
      ${
        window.dev()
          ? ''
          : `
      margin: 0; 
      margin-left: -2px;`
      }
      `;
    }

    case 'center': {
      return '';
    }

    case 'end': {
      return `
      justify-content: end !important;
      ${
        window.dev()
          ? ''
          : `
      margin: 0; 
      margin-right: -2px;`
      }
      `;
    }

    case 'default': {
      return '';
    }
  }
}
